import{j as r}from"./chunk-GEPA7FLG.js";r();import{gql as t}from"@apollo/client";var n=t`
  query taxPerAction(
    $contractAddress: String
    $farmDetailsArgs: FarmDetailsArgs
  ) {
    taxPerAction(
      contractAddress: $contractAddress
      farmDetailsArgs: $farmDetailsArgs
    ) {
      token {
        identifier
        name
        decimals
      }
      amount
    }
  }
`;export{n as a};
//# sourceMappingURL=chunk-JEHNNF35.js.map
